module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer004",
      "role": "doc-toc"
    }
  }, [_c('p', {
    staticClass: "TOCtitle"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('a', {
    attrs: {
      "href": "#/Buried#_idTextAnchor001"
    }
  }, [_vm._v("Buried")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_c('span', {
    attrs: {
      "href": "#/Untraceable#_idTextAnchor021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Untraceable")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCitem"
  }, [_vm._v("Excerpt from "), _c('span', {
    attrs: {
      "href": "#/Excerpt#_idTextAnchor044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Treacherous Mountain Investigation")]), _vm._v(" by Stephanie M. Gammon")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed392ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table_of_Contents.vue
// module id = 69
// module chunks = 0